////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
///////////////// D) FUNCTIONAL PART
/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

//	SCREEN-CLASS
	var mobileBody = function(){
		$('body').addClass('mobile');
		if(mediaType=='monitor') $('body').removeClass('mobile');
	};

//	INITIALIZE SLICK SLIDER for BLog

	var initSlickNews = function(classSelectorEvents){
		var $cardNews = $(classSelectorEvents);
		
		if(mediaType != 'monitor') {
			$cardNews.not('.slick-initialized').slick({
				dots: true,
				infinite: true,
				speed: 300,
				slidesToShow: 1,
				centerMode: false,
				variableWidth: false,
				arrows: false,
				adaptiveHeight: true,
				centerPadding: '0px'
			});
		}
	};



// TEASERSLIDER
	var initSlickTeaserNav = function() {
		$('.teaser-content-wrapper').slick({
			dots: true,
			infinite: false,
			speed: 300,
			slidesToShow: 1,
			centerMode: false,
			variableWidth: true,
			arrows : false
		});
	};

	var initSlickEmployee = function(slickEmloyeeClass) {
		$(slickEmloyeeClass).slick({
			dots: true,
			infinite: false,
			speed: 300,
			slidesToShow: 1,
			centerMode: false,
			variableWidth: false,
			arrows : false
		});

	};


	var initSlickVideo = function(slickVideoClass) {
		$(slickVideoClass).slick({
			dots: false,
			infinite: false,
			speed: 300,
			slidesToShow: 1,
			centerMode: false,
			variableWidth: false,
			arrows : true,
			useCSS: false // IE BUGFIX - SO SECOND SLIDE IS NOT SHOWN TO EARLY
		});
	};

	var initSliderNextEvents = function() {
		const $nextEventsContainer = $('.next-events-slick.on-desktop .news-list-view.events');

		if ($nextEventsContainer.length > 0 && !$nextEventsContainer.hasClass('slick-initialized')) {
			$nextEventsContainer.slick({
				dots: true,
				infinite: false,
				speed: 300,
				slidesToShow: 1,
				centerMode: false,
				variableWidth: false,
				arrows: false
			});
		}
	};

	var initSliderNextEventsMobile = function() {
		const $nextEventsContainer = $('.next-events-slick.on-mobile .news-list-view.events');

		if ($nextEventsContainer.length > 0 && !$nextEventsContainer.hasClass('slick-initialized')) {
			$nextEventsContainer.slick({
				dots: true,
				infinite: false,
				speed: 300,
				slidesToShow: 1,
				centerMode: false,
				variableWidth: false,
				arrows: false
			});
		}
	};

//	INITIALIZE SLICK SLIDER for News

	var initSlickEvents = function(classSelectorEvents){
		var $cardNews = $(classSelectorEvents);
		
		if(mediaType != 'monitor') {
			$cardNews.not('.slick-initialized').slick({
				dots: true,
				infinite: true,
				speed: 300,
				slidesToShow: 1,
				centerMode: false,  // Auf false setzen
				variableWidth: false,
				arrows: false,
				adaptiveHeight: true,  // Auf false setzen für gleiche Höhe
				centerPadding: '0px'  // Kein Padding
			});
		}
	};


	var initSlickSmallEvent = function(classSelectorSmallEvents){
		var $cardNews = $(classSelectorSmallEvents);
		$cardNews.not('.slick-initialized').slick({
			dots: true,
			infinite: false,
			speed: 300,
			slidesToShow: 1,
			centerMode: false,
			variableWidth: false,
			arrows : false
		});
	};

//	INITIALIZE SLICK SLIDER for Header

	var initSlick = function(classSelector){
		var $card = $(classSelector);
		$card.not('.slick-initialized').slick({
			dots: false,
			infinite: false,
			speed: 300,
			slidesToShow: 1,
			centerMode: false,
			variableWidth: true,
			arrows : false
		});
	};

//	INITIALIZE SLICK SLIDER for Gallery
	var initSlickGallery = function(classSelectorGallery){
		var $card = $(classSelectorGallery);
		
		// Erst den Event binden
		$card.on('init', function(event, slick) {
			console.log('aaa');
			// Container-Styling
			$(this).find('.slick-slide').css({
				'height': 'auto',
				'position': 'relative'
			});
			
			// Bild-Styling
			$(this).find('.slick-slide img').css({
				'width': '100%',
				'height': '100%',
				'display': 'block',
				'object-fit': 'cover'
			});

			// Lazy Loading auslösen
			$(this).find('img.lazyload').each(function() {
				var $img = $(this);
				var src = $img.data('src');
				if (src) {
					$img.attr('src', src);
					$img.removeClass('lazyload');
				}
			});
		});

		// Dann den Slider initialisieren
		$card.not('.slick-initialized').slick({
			dots: false,
			infinite: false,
			speed: 300,
			slidesToShow: 1,
			centerMode: false,
			variableWidth: false,
			arrows: true
		});
	};

	var slickHeaderWidth = function() {
		if($('.media-main .slick-slider .slick-slide').length > 0){
			var windowWidth = $(window).width(),
				sliderEl = $('.media-main .slick-slider .slick-slide');
			sliderEl.css('width', windowWidth);
		}
	};


	// INIT MAIN MENU
	var calcMainMenu = function(){
		// Width (padding) für main dropdown berechnen / left space für zweites level in dropdown berechnen
		var widthNav = $('.nav-main').outerWidth();
		var overflowWidthMenu = $('.wrapper-main').width() - $('.nav-main').outerWidth(),
			paddingMenu = overflowWidthMenu/2,
			extraPadding =  widthNav / 100 * 33,
			widthFirstLevel = $('.nav-main .menu.submenu li:last-child').outerWidth(),
			leftSpaceSecond = widthFirstLevel + paddingMenu,
			$subMenu = $('.nav-main .menu.submenu'),
			$subSubMenu = $('.nav-main .menu.submenu li.is-dropdown-submenu-parent ul.submenu');


		//$subMenu.css({paddingLeft: paddingMenu, paddingRight: paddingMenu + extraPadding}); // Inkl. Teaser-Slider
		$subMenu.css({paddingLeft: paddingMenu, paddingRight: paddingMenu});	// No Teaser-Slider
		//$subSubMenu.css({left: leftSpaceSecond});
		var $widthTeaser =  $subMenu.width() / 2;
		$('.nav-main .teaser-content').css('width', $widthTeaser);

	};

// 	BUILD TOC MENU STRUCTURE

	var buildMenuTOC = function() {

		// find all content elements which should arise in the toc menu
		var tocEntries = '.content-main .csc-default[data-sectionindex=1]';

		// find place for toc menu
		var tocMenuUL = 'ul.toc-list';

		// collect toc entry data
		var tocEntry = '';
		$(tocEntries).each(function (index) {
			var tocSectionName = $(this).data('sectionname');
			var tocOrigUid = $(this).data('origuid');
			var tocCtype = $(this).data('ctype');
			var tocSectionTarget = $(this).attr('id');

			if (tocSectionName) {
				tocEntry += '<li class="" data-toc="' + tocSectionTarget + '" data-origuid="' + tocOrigUid + '" data-ctype="' + tocCtype + '">';
				tocEntry += '<a href="#' + tocSectionTarget + '" target="_self">';
				tocEntry += tocSectionName;
				tocEntry += '</a></li>';
			}
		});

		// check if a call-to-action button is available
		var tocMenuEnter = $(tocMenuUL).find('li');

		if ($(tocMenuEnter).length > 0) {
			// call-to-action button available - put toc-menu before the cta-button
			$(tocMenuEnter).before(tocEntry);
		} else {
			// NO call-to-action button found - append toc-menu to ul
			$(tocMenuUL).append(tocEntry);
		}

		getTocMenuDimension();
		activeToc();
	};

	var getTocMenuDimension = function(){
		$(menuToc.class+' li').each(function(){
			menuToc.contentWidth +=$(this).outerWidth();
		});

		menuToc.menuWidth = $('.nav-toc').outerWidth();
		menuToc.arrowWith = $(menuToc.class+' .arrows').outerWidth();
		menuToc.availableDistance = menuToc.contentWidth - menuToc.menuWidth;
	};

//	AKTIVE AUSZEICHNUNG TOC NAV

	var lastScrollTop = 0;

	var activeToc = function(){
		var containerToc = '.controls-main';
		$(containerToc+' '+menuToc.class+' ul li').each(function(index) {
			if($(this).data( "toc" )!=null){
				$('.content-main').find('#'+$(this).data( "toc" )).bind('inview', function (event, visible) {
					$(containerToc+' '+menuToc.class+' ul').find('.current').removeClass('current');
					if (visible === true) {
						//$(containerToc+' '+menuToc.class+' ul').find("[data-toc='" + $(this).attr('id')+ "'] a").addClass('act');
						$(containerToc+' '+menuToc.class+' ul').find("[data-toc='" + $(this).attr('id')+ "']").addClass('act');
					} else {
						//$(containerToc+' '+menuToc.class+' ul').find("[data-toc='" + $(this).attr('id')+ "'] a").removeClass('act');
						$(containerToc+' '+menuToc.class+' ul').find("[data-toc='" + $(this).attr('id')+ "']").removeClass('act');
					}

					//$(containerToc+' '+menuToc.class+' ul').find('.act').eq(0).addClass('current');
					//$(containerToc+' '+menuToc.class+' ul').find('.act').eq(0).attr('id','current');

					var $stage = $(containerToc+' '+menuToc.class+' ul').find('li.act').eq(0);
					$stage.addClass('current');

					setTimeout(function(){
						menuToc.timerValue=tocHorizontalAutoScroll($stage);
					}, 300);

				});
			}
		});

		$(window).scroll(function() {
			const st = $(this).scrollTop();
			const scrollDirection = st > lastScrollTop ? 'down' : 'up';
			
			if (scrollDirection === 'down') {
				$('.toc-nav-container .sticky').addClass('has-top-offset');
			} else {
				$('.toc-nav-container .sticky').removeClass('has-top-offset');
			}
			
			// Bestehende Logik beibehalten
			var scrollPos = $(window).scrollTop();
			$('.toc-list li').each(function () {
				var currLink = $(this);
				var refElement = $('#' + currLink.data('toc'));
				
				if (refElement.length > 0) {
					if (refElement.position().top - 100 <= scrollPos && refElement.position().top + refElement.height() > scrollPos) {
						$('.toc-list li').removeClass('current');
						currLink.addClass('current');
					} else {
						currLink.removeClass('current');
					}
				}
			});
			
			lastScrollTop = st; // Aktuelle Position für nächsten Vergleich speichern
		});

		/*
		//	ADD CLICK-HANDLER TO TOC-NAV LEFT-RIGHT ARROWS
		$('.scroll-helper .arrow-left').bind('click',function(){
			$(menuToc.class).stop().animate({scrollLeft:'-=200px'}, 500, 'swing', function(){
				updateArrowScrollState($(this).scrollLeft());
			});
		});
		$('.scroll-helper .arrow-right').bind('click',function(){
			$(menuToc.class).stop().animate({scrollLeft:'+=200px'}, 500, 'swing', function(){
				updateArrowScrollState($(this).scrollLeft());
			});
		});
		*/
	};


//  AUTO SCROLL HORIZONTAL

	var tocHorizontalAutoScroll = function(el){

		clearTimeout(menuToc.timerValue);
		var $el = $(el),
			navigationPosition = $('.nav-toc, .toc-list-calendar').scrollLeft(),
			distanceLeft = 0,
			currentPosition = false;

		try {
			currentPosition = $('.nav-toc').offset().left - $el.offset().left;
		} catch(err) {
			currentPosition = false;
		}

		if(currentPosition) {
			distanceLeft =  navigationPosition + (currentPosition * -1);
			$('.nav-toc, .toc-list-calendar').stop().animate({scrollLeft:distanceLeft+'px'}, 500, 'swing', function(){
				updateArrowScrollState($('.nav-toc').scrollLeft());
			});

			$('.nav-toc, .toc-list-calendar').stop().animate({scrollLeft:distanceLeft+'px'}, 500, 'swing', function(){
				updateArrowScrollState($('.nav-toc').scrollLeft());
			});
		}
	};


	var updateArrowScrollState = function(pos){
		var $arrowLeft =  $('.scroll-helper .arrow-left'),
            $arrowRight =  $('.scroll-helper .arrow-right');

		$arrowLeft.removeClass('visible');
		$arrowRight.removeClass('visible');
		/*

		if(menuToc.availableDistance > 0){
			if(pos>menuToc.arrowWith) {
				$arrowLeft.addClass('visible');
			}else{
				$arrowLeft.removeClass('visible');
			}

			if(pos<=menuToc.availableDistance){
				$arrowRight.addClass('visible');
			}else{
				$arrowRight.removeClass('visible');

			}
		}else{
			//	INHALT MUSS NICHT GESCROLLT WERDEN
			$arrowLeft.removeClass('visible');
			$arrowRight.removeClass('visible');
		}

		console.log('pos',pos);
		console.log('tocSettings',menuToc);
		*/
	};

	/*
	var getTocContentWidth = function(){
		tocWidth = $('.toc-list-wrapper ul li').outerWidth();
	};
	*/


//	SET BACK-TO-TOP-BUTOTN VISIBLE

	var initBackToTop = function () {
		var backToTop = $('[data-functionality*="' + menuTopLink + '"]');
		$(window).scroll(function(){
			if ($(this).scrollTop() > 500) {
				$(backToTop).fadeIn();
			} else {
				$(backToTop).fadeOut();
			}
		});
		$(backToTop).bind('click', function(e) {
			$('body,html').animate({scrollTop:0}, 800);
		});
	};


//	BIND CLICK FUNCTION TO HEADER

	var initAdditionalFormHandler = function(){
		$('#tiny-searchform fieldset label, #searchformMobile fieldset label').on('click', function(){
			$(this).parentsUntil('div').submit();
		});
	};


 var metaNavigation = function(){
	var widthRow = $('.nav-meta-wrapper .row').width();
	var widthWindow = $(window).width();
	var widthBg =  (widthWindow - widthRow) / 2;
	$('.nav-quickaccess .state .bg-state').css('width', widthBg + 158);
};


var metaDropdown = function(){
	$('.nav-meta li.dropdown a').click(function() {
		$(this).change();
	});
	$('.nav-meta li.dropdown').on('change', function(){
		var $thisLi = $(this).find('li.submenusub'),
			widthLi = $thisLi.outerWidth(),
			countLi = $thisLi.length;
		$(this).find('ul.menu').css('width', widthLi*countLi);
	})
};

var searchToggle = function(){
	$('.search-toggle').on('click', function(){
		$(this).next('form').toggleClass('open');
		$(this).toggleClass('open');
		$('input[name="tx_indexedsearch_pi2[search][sword]"]').focus();
		return false;
	});
};

var initParallax = function () {
	$('.parallax-window').parallax();
};
var initParallaxHeader = function () {
	$('.parallax-window-header').parallax({
		naturalWidth: 2224,
		naturalHeight: 850
	});
};


var initAccParaCallback = function() {
	// FIX ISSUE WHERE ACCORDION IS OVERFLOWING PARALLAX
	$('.accordion')
		.on("down.zf.accordion", function() {
			$(window).trigger('resize.px.parallax');
		})
		.on("up.zf.accordion", function() {
			$(window).trigger('resize.px.parallax');
		});
};

var initTextImageParallaxCallback = function() {
	var lazyImage = $('img.lazyload');
	lazyImage.on('load', function(){
		$(window).trigger('resize.px.parallax');
	});
}


var initEmployeeDetail = function () {
	$('.detail-link-employee').on('click', function(){
		var singleEmployee = '.single-employee';
		var $closestEmployee = $(this).closest(singleEmployee);
		if($(singleEmployee).hasClass('open')) $(singleEmployee).removeClass('open');
		$closestEmployee.toggleClass('open');
		var windowWidth = $(window).width() * 0.8;

		if($(window).width() < 1020) {
			windowWidth = $(window).width() - 40;
		}

		$closestEmployee.find('.employee-detail').css('width',windowWidth);
	});
	$(document).on("click", function (e) {
		if ($(e.target).is('.detail-link-employee') === false) {
			$('.single-employee').removeClass("open");
		}
	});

};

var initFloating = function(){
	// trim polyfill : https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/Trim
	if (!String.prototype.trim) {
		(function() {
			// Make sure we trim BOM and NBSP
			var rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;
			String.prototype.trim = function() {
				return this.replace(rtrim, '');
			};
		})();
	}

	[].slice.call( document.querySelectorAll( 'input.input__field' ) ).forEach( function( inputEl ) {
		// in case the input is already filled..
		if( inputEl.value.trim() !== '' ) {
			classie.add( inputEl.parentNode, 'input--filled' );
		}

		// events:
		inputEl.addEventListener( 'focus', onInputFocus );
		inputEl.addEventListener( 'blur', onInputBlur );
	} );

	function onInputFocus( ev ) {
		classie.add( ev.target.parentNode, 'input--filled' );
		classie.add( ev.target.parentNode, 'input--line--filled' );
	}

	function onInputBlur( ev ) {
		if( ev.target.value.trim() === '' ) {
			classie.remove( ev.target.parentNode, 'input--filled' );
			classie.remove( ev.target.parentNode, 'input--line--filled' );
		}else{
			classie.remove( ev.target.parentNode, 'input--line--filled' );
		}
	}
};


// RECHTE SPALTE
var initCourseRightAcc = function() {
	var $rightColEl = $('.sticky-right-metacontent .csc-default');
	$rightColEl.each(function(){
		var $header = $(this).find('header'),
			$thisP = $(this).find('header').next();
		$thisP.toggleClass('container');

		$header.on('click', function(){
			var $thisParent = $(this).parent();
			$thisParent.toggleClass('open');
		})
	});
};


var initLesson = function() {
	var $lesson = $('.calc-lesson');
	// COUNT FROM HEIGHEST AS 100%
	var $countLessons = [];
	$lesson.each(function() {
		$countLessons.push($(this).attr('data-count'));
	});
	var heighestLessonCount = Math.max.apply(Math, $countLessons);
	$lesson.each(function(){
		var $total = heighestLessonCount;
		var $numberOfLessons = $(this).attr('data-count');
		
		var percent = 100 / $total * $numberOfLessons;

		if(percent < 100) {
			percent = percent + 3;
		}

		$(this).css('width', percent+'%');
	});

	// SUM Of ALL LESSONS Calc to All Lessons
	/*$lesson.each(function() {
		lessons = lessons + parseInt($(this).attr('data-count'));
		$('.lesson-total').html(lessons);
	});


	$('.calc-lesson').each(function(){
		var $total = $('.lesson-total').text();
		var $numberOfLessons = $(this).attr('data-count');
		var percent = 100 / $total * $numberOfLessons;

		$(this).css('width', percent+'%');
	});
*/

};

var initPriceTable = function() {
	var $priceTable = $('.price-table');
	$priceTable.each(function() {
		var $totalPrice = $(this).find('th:nth-child(2)').text();
		var $totalText = $(this).find('th:nth-child(1)').text();
		var $priceSlot = $(this).parent().prev('.accordion-title');
		var $priceTopSlot = $('.course-page--header--textbox_price');

		//$priceSlot.append('<div class="total-price-overview">'+$totalText+'<br /><b>'+$totalPrice+'</b></div>');

		$priceSlot.append('<div class="total-price-overview"><b>'+$totalPrice+'</b></div>');

		if ($priceTopSlot.length > 0 && $totalText != '' && $totalPrice != '') {
			//$priceTopSlot.append($totalText+'<div class="course-page--header--textbox_price--value">'+$totalPrice+'</div>');
			//$priceTopSlot.removeClass('hide');
		}

		$priceSlot.addClass('price-accordion');
	});
};

const initNextEvents = function() {
	const $nextEventsSlotMobile = $('.course-page--nextevents.on-mobile .columns');
	const $nextEventsSlotDesktop = $('.course-page--nextevents.on-desktop .columns');
	const $nextEvents = $('.course-page .content-type-list.next-events');
	const slickSliderNextEventsClassOnMobile = '.next-events-slick.on-mobile';
	const slickSliderNextEventsClassOnDesktop = '.next-events-slick.on-desktop';

	// Warten bis das DOM bereit ist
	$(document).ready(function() {
		if($nextEventsSlotMobile.length && $nextEvents.length) {
			// Kopie für Mobile erstellen
			const $mobileClone = $nextEvents.clone();
			//$nextEventsSlotMobile.append($mobileClone);
			// Kurze Verzögerung für DOM-Update
			setTimeout(() => {
				if($(slickSliderNextEventsClassOnMobile).length > 0) {
					initSliderNextEventsMobile();
				}
			}, 100);
		}
		
		if($nextEventsSlotDesktop.length && $nextEvents.length) {
			// Kopie für Desktop erstellen
			const $desktopClone = $nextEvents.clone();
			//$nextEventsSlotDesktop.append($desktopClone);
			// Kurze Verzögerung für DOM-Update
			setTimeout(() => {
				if($(slickSliderNextEventsClassOnDesktop).length > 0) {
					initSliderNextEvents();
				}
			}, 100);
		}
	});
}

var playCourseVideo = function() {
	var video=document.getElementById("courseVideo");
	video.play();
};


// HOOME
var specialVideoFeature = function() {

	var $nextButton = $('.slick-slider-video .slick-next');
	var $prevButton = $('.slick-slider-video .slick-prev');
	var $sliderTextbox = $('.home-slider .slider-element-wrapper');
	var $sliderButton = $('.home-slider .slider-button-wrapper');

	$('.home-slider.video .slide-video-special.slick-slide video').trigger('pause');
	$prevButton.hide();
	$('.slick-slider-video .slick-active video').trigger('play');

	$nextButton.on('click', function(){

		var activeVideoId = $('.slick-slider-video .slick-active video').attr('id');
		var $activeVideo = $('.slick-slider-video video#'+activeVideoId+'');

		$activeVideo.trigger('play');
		$activeVideo.prop('loop', false);

		$(this).hide();
		$sliderTextbox.hide();
		$sliderButton.hide();
		$prevButton.show();
	});

	$prevButton.on('click', function(){
		$('.home-slider.video .slide-video-special.slick-slide video').trigger('pause');

		var activeVideoId = $('.slick-slider-video .slick-active video').attr('id');
		var $activeVideo = $('.slick-slider-video video#'+activeVideoId+'');

		$activeVideo.trigger('play');
		$activeVideo.prop('loop', true);
		$nextButton.show();
		$sliderTextbox.show();
		$sliderButton.show();
		$(this).hide();
	});
};


// 	COOKIE

	function initCookie(){
		$('.close-cookie').on('click', function(){
			Cookies.set('likecookie', 'true', { expires: 365 });
			$('.we-love-cookies').hide();
		});

		if(Cookies.get('likecookie')){
			$('.we-love-cookies').hide();
		} else {
			$('.we-love-cookies').show();
		}
	};


// Video in Fancy Box
var initFancyVideo = function() {
	$('.fancybox-media.extern').fancybox({
		openEffect  : 'none',
		closeEffect : 'none',
		helpers : {
			media : {}
		}
	});

	$('.fancybox-media.intern').fancybox({
		openEffect  : 'none',
		closeEffect : 'none',
		type: 'iframe',
		width: '640px',
		height: '400px',
		helpers : {
			media : {}
		}
	});
}

// Count Lessons
var initLessonsCount = function() {
	let hwdtotal = 0;
	let tktotal = 0;
	let counttotal = 0;

	$('.single-lesson .hwd-count').each(function() {
		if($(this).data('hwdcount') != '') {
			hwdtotal = hwdtotal + parseInt($(this).data('hwdcount'));
		}
	});
	$('.single-lesson .tk-count').each(function() {
		if($(this).data('tkcount') != '') {
			tktotal = tktotal + parseInt($(this).data('tkcount'));
		}
	});
	$('.single-lesson .total-count').each(function() {
		if($(this).data('countall') != '') {
			counttotal = counttotal + parseInt($(this).data('countall'));
		}
	});

	$('.total-hwd').html(hwdtotal);
	$('.total-tk').html(tktotal);
	$('.total-all').html(counttotal);
}


// Navigation Items with filter function
var filterFunctionNavigation = function(){
	var urlParams = new URLSearchParams(window.location.search);
	var has_filterid = urlParams.has('filterid');
	var url_filterid = urlParams.get('filterid');

	if(has_filterid) {
		if ($('.filter-list').length > 0) {
			$('.' + url_filterid + '').click();
		}
	}

	// Function to check if an item matches the filter criteria
	const checkItemVisibility = (item, selectedFilters, searchText) => {
		const $item = $(item);
		let isVisible = true;

		// Check category filter
		if (selectedFilters && selectedFilters !== '') {
			const itemCategories = $item.data('filter-category-calendar') || '';
			isVisible = selectedFilters.split(',').every(filter => 
				filter === '' || itemCategories.includes(',' + filter + ',')
			);
		}

		// Check search text
		if (isVisible && searchText && searchText !== '') {
			const searchData = $item.data('filter-search-calendar') || '';
			isVisible = searchData.toLowerCase().includes(searchText.toLowerCase());
		}

		return isVisible;
	};

	// Function to update visibility and colors
	const updateVisibilityAndColors = () => {
		const selectedFilters = $('.filter-list a.active').data('filter-value') || '';
		const searchText = $('.filter-search input').val() || '';
		
		let hasVisibleItems = false;
		let colorIndex = 0;
		const colors = ['green', 'blue', 'yellow'];

		// First pass: Update visibility
		$('.news-list-view .filter-item').each(function() {
			const isVisible = checkItemVisibility(this, selectedFilters, searchText);
			$(this).toggleClass('hide', !isVisible);
			if (isVisible) hasVisibleItems = true;
		});

		// Show/hide empty state message
		//$('.filter-empty').toggleClass('hide', hasVisibleItems);

		// Second pass: Update colors and handle month headers
		let currentMonth = null;
		$('.news-list-view .filter-item').each(function() {
			const $item = $(this);
			
			if ($item.hasClass('grouped-subtitle')) {
				// This is a month header
				currentMonth = $item;
				const monthId = $item.attr('id');
				
				// Check if there are any visible items for this month
				const hasVisibleEvents = $item.nextUntil('.grouped-subtitle')
					.filter(':not(.hide)').length > 0;
				
				$item.toggleClass('hide', !hasVisibleEvents);
			} else if (!$item.hasClass('hide')) {
				// Remove all color classes and add the new one
				$item.removeClass('green blue yellow')
					.addClass(colors[colorIndex]);
				colorIndex = (colorIndex + 1) % colors.length;
			}
		});
	};

	// Bind events
	$('.filter-list a').on('click', function(e) {
		e.preventDefault();
		$('.filter-list a').removeClass('active');
		$(this).addClass('active');
		updateVisibilityAndColors();
	});

	$('.filter-search input').on('keyup', function() {
		updateVisibilityAndColors();
	});

	// Initial update
	updateVisibilityAndColors();
};


var schulanmeldungForm = function() {
	// prevent submit on enter
	const form = document.querySelector('form.powermail_form_72');
	form.addEventListener('keydown', function(event) {
		if (event.key === 'Enter') {
			event.preventDefault();
		}
	});
	// treatment for nationality/place of origin
	const selectElement = document.getElementById('powermail_field_nationalitaet');
	const heimatortField = document.getElementById('powermail_field_heimatort');
	selectElement.addEventListener('change', function() {
		const selectedValue = selectElement.value;
		console.log(selectedValue);
		if (selectedValue !== 'Schweiz') {
			heimatortField.value = selectedValue;
			heimatortField.focus();
		} else {
			heimatortField.value = '';
		}
	});
};

var initMobileNav = function() {
	const mobileNavToggle = $('#mobile-menu');
	const mobileNavContent = $('.mobile-nav-wrapper');
	const mobileNavToggleAct = $('#mobile-menu-act');

	// Initialisierung
	if (window.innerWidth > 1024) {
		if ($('body').hasClass('start')) {
			$('body').toggleClass('mobile-nav-open');
			mobileNavContent.toggleClass('open');
		}
	}
	
	if (mobileNavToggle.length > 0) {
		mobileNavToggle.on('click', function(e) {
			e.preventDefault();
			$('body').toggleClass('mobile-nav-open');
			mobileNavContent.toggleClass('open');
		});
	}

	if (mobileNavToggleAct.length > 0) {
		mobileNavToggleAct.on('click', function(e) {
			e.preventDefault();
			$('body').toggleClass('mobile-nav-open');
			if ($('body').hasClass('mobile-subs-open')) {
				$('body').removeClass('mobile-subs-open');
				$('body').removeClass('mobile-subs-open__main');
				$('body').removeClass('mobile-subs-open__meta');
			}
			mobileNavContent.toggleClass('open');
			$('.subs-opened').removeClass('subs-opened');
			$('.tab-content').removeClass('open');
		});
	}

	// Event-Delegation für alle Navigation-Items
	$('.mobile-nav-wrapper--top-row-list').on('click', '.lvl1.has-children:not(.subs-opened)', function(e) {
		e.preventDefault();
		const tempItem = $(this);
		const tempItemContent = tempItem.find('.tab-content');
		
		// Verzögerung für sanfteren Übergang
		setTimeout(() => {
			$('body').removeClass('mobile-subs-open__meta');
			$('body').addClass('mobile-subs-open');
			$('body').addClass('mobile-subs-open__main');
			tempItem.addClass('subs-opened');
			tempItemContent.addClass('open');
		}, 50);
	});

	$('.mobile-nav-wrapper--top-row-secondnavlist').on('click', '.lvl1.has-children:not(.subs-opened)', function(e) {
		e.preventDefault();
		const tempItem = $(this);
		const tempItemContent = tempItem.find('.tab-content');
		
		// Verzögerung für sanfteren Übergang
		setTimeout(() => {
			$('body').removeClass('mobile-subs-open__main');
			$('body').addClass('mobile-subs-open');
			$('body').addClass('mobile-subs-open__meta');
			tempItem.addClass('subs-opened');
			tempItemContent.addClass('open');
		}, 50);
	});

	const backLink = $('.mobile-nav-wrapper--top-row-backlink a');
	if (backLink.length > 0) {
		backLink.on('click', function(e) {
			e.preventDefault();
			
			// Erst Tab-Content schließen
			$('.tab-content').removeClass('open');
			
			// Dann mit Verzögerung die anderen Klassen entfernen
			setTimeout(() => {
				$('body').removeClass('mobile-subs-open');
				$('.subs-opened').removeClass('subs-opened');
			}, 0);
		});
	}
}

var initBzrWzrSwitch = function() {
    var $switchInput = $('#bzrSwitch');
    
    if ($switchInput.length) {
		const $clickItem = $('.switch-paddle span');

		$clickItem.on('click', function() {
			const $url = $(this).data('url');
			window.location.href = $url;
		});
		
        /*
		$switchInput.on('change', function() {
            var $paddle = $(this).siblings('.switch-paddle');
            var $activeSpan = $paddle.find('span:first-child');  // BZR
            var $inactiveSpan = $paddle.find('span:last-child'); // WZR
            
            if (this.checked) {
                // WZR active
                $activeSpan.removeClass('switch-active').addClass('switch-inactive');
                $inactiveSpan.removeClass('switch-inactive').addClass('switch-active');
            } else {
                // BZR active
                $activeSpan.removeClass('switch-inactive').addClass('switch-active');
                $inactiveSpan.removeClass('switch-active').addClass('switch-inactive');
            }
        });
        */
    }
};

var initPowermail = function() {
	// Select Dropdown Toggle
	$('.powermail_select').on('click', function() {
		$(this).closest('.powermail_fieldwrap').toggleClass('open');
	});
	
	$(document).on('click', function(e) {
		if (!$(e.target).closest('.powermail_fieldwrap').length) {
			$('.powermail_fieldwrap').removeClass('open');
		}
	});
	
	// Textarea Focus Toggle
	$('.powermail_textarea').on('focus', function() {
		$(this).closest('.powermail_fieldwrap_textarea').addClass('focused');
	}).on('blur', function() {
		if (!$(this).val()) {
			$(this).closest('.powermail_fieldwrap_textarea').removeClass('focused');
		}
	});
	
	$('.powermail_textarea').each(function() {
		if ($(this).val()) {
			$(this).closest('.powermail_fieldwrap_textarea').addClass('focused');
		}
	});
};

var initSearch = function() {
    const navSearch = document.querySelector('#nav-search');
    const closeSearch = document.querySelector('.close-search');

    if (navSearch) {
        navSearch.addEventListener('click', function(e) {
            // Aktuelle URL in localStorage speichern
            localStorage.setItem('previousPage', window.location.href);
        });
    }

    if (closeSearch) {
        closeSearch.addEventListener('click', function(e) {
			console.log('closeSearch');
            e.preventDefault();
            const previousPage = localStorage.getItem('previousPage');
            if (previousPage) {
                localStorage.removeItem('previousPage');
                window.location.href = previousPage;
            } else {
                window.location.href = '/';
            }
        });
    }
};

var initTableStyling = function() {
	const tables = document.querySelectorAll('.contenttable');

	if (tables) {
		tables.forEach(table => {
			const cells = table.querySelectorAll('td');

			cells.forEach(cell => {
				if (cell.innerHTML === '&nbsp;') {
					cell.classList.add('empty');
				}
			});
		});
	}
};

const initBadgeAnimations = function() {
	console.log('initBadgeAnimations');

    const options = {
        root: null,
        rootMargin: '0px',
        threshold: 0.1
    };

    // Callback für den Observer
    const callback = (entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add('visible');
                observer.unobserve(entry.target);
            }
        });
    };

    // Observer erstellen
    const observer = new IntersectionObserver(callback, options);

    // Alle Badges beobachten
    const badges = document.querySelectorAll('.badge-container');
    
    // Initial Check für bereits sichtbare Badges
    badges.forEach((badge, index) => {
        const rect = badge.getBoundingClientRect();
        const isVisible = (
            rect.top >= 0 &&
            rect.left >= 0 &&
            rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
            rect.right <= (window.innerWidth || document.documentElement.clientWidth)
        );

        if (isVisible) {
            // Gestaffelte Verzögerung für sichtbare Badges
            setTimeout(() => {
                badge.classList.add('visible');
            }, 300 + (index * 200)); // 300ms Basis-Verzögerung + 200ms pro Badge
        } else {
            // Nicht sichtbare Badges mit Observer überwachen
            observer.observe(badge);
        }
    });
};

const employeeListRandomColor = function() {
	const employeeList = document.querySelectorAll('.contact-person.employee-filter .single-employee');
	const colors = ['320', '330', '340', '350'];
	let lastColor = null;

	if (employeeList) {
		employeeList.forEach(employee => {
			let availableColors = colors.filter(color => color !== lastColor);
			const randomColor = availableColors[Math.floor(Math.random() * availableColors.length)];
			employee.classList.add('bg-' + randomColor);
			lastColor = randomColor;
		});
	}
};

const handlePrintLink = function() {
	const printLink = document.querySelectorAll('.print-link');

	if (printLink) {
		printLink.forEach(link => {
			link.addEventListener('click', function() {
				window.print();
			});
		});
	}
}

// Event List Toggle
const initEventListToggle = function() {
    const sliders = document.querySelectorAll('.course-page--nextevents .news-list-view.events');
    if (!sliders.length) return;

    const sliderStates = new Map();

    sliders.forEach(slider => {
        const articles = slider.querySelectorAll('article');
        sliderStates.set(slider, !slider.classList.contains('collapsed'));

        articles.forEach(article => {
            const title = article.querySelector('.event-list-title');
            const collapse = article.querySelector('.event-list-collapse-container');
            if (title && collapse) {
               
                collapse.style.overflow = 'hidden';
                collapse.style.transition = 'max-height 0.4s cubic-bezier(0.4,0,0.2,1)';
                
                
                if (sliderStates.get(slider)) {
                    collapse.style.maxHeight = collapse.scrollHeight + 'px';
                } else {
                    collapse.style.maxHeight = '0px';
                }

				if (window.innerWidth > 1024) {
                	title.addEventListener('click', function() {
						const newState = !sliderStates.get(slider);
						sliderStates.set(slider, newState);
						
						articles.forEach(a => {
							const c = a.querySelector('.event-list-collapse-container');
							if (c) {
								if (newState) {
									c.style.maxHeight = c.scrollHeight + 'px';
								} else {
									c.style.maxHeight = '0px';
								}
							}
						});
                        slider.classList.toggle('collapsed', !newState);
                    });
				}
            }
        });
    });

    // Make sliderStates available to other functions
    window.sliderStates = sliderStates;
};

// Employee List Toggle
const initEmployeeListToggle = function() {
    const employeeSections = document.querySelectorAll('.content-type-flemployeescustom_employeesshowbelonging');
    if (!employeeSections.length) return;

    // Store visibility state for each section
    const sectionStates = new Map();

    employeeSections.forEach(section => {
        const header = section.querySelector('header');
        const employeeList = section.querySelector('.tx-fl-employees');
        
        if (!employeeList) return;
        
        // Set initial state based on collapsed class
        sectionStates.set(section, !section.classList.contains('collapsed'));

        if (header) {
            // Set initial state for smooth transition
            employeeList.style.overflow = 'hidden';
            employeeList.style.transition = 'max-height 0.4s cubic-bezier(0.4,0,0.2,1)';
            
            // Set initial height based on visibility state
            if (sectionStates.get(section)) {
                employeeList.style.maxHeight = employeeList.scrollHeight + 'px';
            } else {
                employeeList.style.maxHeight = '0px';
            }

            header.addEventListener('click', function() {
                const newState = !sectionStates.get(section);
                sectionStates.set(section, newState);
                
                if (newState) {
                    employeeList.style.maxHeight = employeeList.scrollHeight + 'px';
                } else {
                    employeeList.style.maxHeight = '0px';
                }
                section.classList.toggle('collapsed', !newState);
            });
        }
    });

    // Make sectionStates available to other functions
    window.sectionStates = sectionStates;
};


const initStickyCollapseHandler = function() {
    const stickyContainer = document.querySelector('.sticky.sticky-row');
    if (!stickyContainer) return;

    const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            if (mutation.attributeName === 'class') {
                const isStuck = stickyContainer.classList.contains('is-stuck');
                
                // Events Container collapse
                const eventSliders = document.querySelectorAll('.course-page--nextevents .news-list-view.events');
                eventSliders.forEach(slider => {
                    const articles = slider.querySelectorAll('article');
                    articles.forEach(article => {
                        const collapse = article.querySelector('.event-list-collapse-container');
                        if (collapse) {
                            if (isStuck) {
                                collapse.style.maxHeight = '0px';
                                slider.classList.add('collapsed');
                                // Update the stored state
                                if (window.sliderStates) {
                                    window.sliderStates.set(slider, false);
                                }
                            } else {
                                collapse.style.maxHeight = collapse.scrollHeight + 'px';
                                slider.classList.remove('collapsed');
                                // Update the stored state
                                if (window.sliderStates) {
                                    window.sliderStates.set(slider, true);
                                }
                            }
                        }
                    });
                });

                // Employee Container collapse
                const employeeSections = document.querySelectorAll('.content-type-flemployeescustom_employeesshowbelonging');
                employeeSections.forEach(section => {
                    const employeeList = section.querySelector('.tx-fl-employees');
                    if (employeeList) {
                        if (isStuck) {
                            employeeList.style.maxHeight = '0px';
                            section.classList.add('collapsed');
                            // Update the stored state
                            if (window.sectionStates) {
                                window.sectionStates.set(section, false);
                            }
                        } else {
                            employeeList.style.maxHeight = employeeList.scrollHeight + 'px';
                            section.classList.remove('collapsed');
                            // Update the stored state
                            if (window.sectionStates) {
                                window.sectionStates.set(section, true);
                            }
                        }
                    }
                });
            }
        });
    });

    // Starte die Beobachtung
    observer.observe(stickyContainer, {
        attributes: true,
        attributeFilter: ['class']
    });
};

const handleTableStyling = function() {
	const tables = document.querySelectorAll('.contenttable');

	if (tables) {
		tables.forEach(table => {
			let tdMaxCountPerRow = 0;

			const rows = table.querySelectorAll('tr');
			rows.forEach(row => {
				const tds = row.querySelectorAll('td');
				if (tds.length > tdMaxCountPerRow) {
					tdMaxCountPerRow = tds.length;
				}
			});

			table.classList.add('table-' + tdMaxCountPerRow + '-cols');
		})
	}
}

const initScrollToTopOnFormPage = function() {
	$(window).on('load', function () {
		const formButton = document.querySelector('.powermail_create a');
		if (formButton) {
			setTimeout(function () {
				// Fokus entfernen
				$('input:focus').blur();

			// Hash aus URL entfernen (verhindert Scroll zu Anker)
			if (window.location.hash) {
				//history.replaceState(null, null, window.location.pathname + window.location.search);
			}

			// Hochscrollen
				$('html, body').scrollTop(0);
			}, 200);
		}
	});
}